import React, { FC } from 'react';

import { CartButton } from 'src/shoppe/elements/CartButton';

import styles from './index.module.sass';

const CartToggle: FC = () => <CartButton className={styles.button} />;

export default CartToggle;
